import { PrivacyPolicy } from 'features/terms-dialog/components/privacy-policy'

export const PrivacyPolicyPage: React.FC = () => {
  return <PrivacyPolicy />
}
